import React, { useState, useEffect } from 'react';
import './CadastrarPrefeitura.css';
import { message } from 'antd';
import api from '../../../../services/api';
import API_CONFIG from '../../../../config/api.config';

const initialState = {
  razaoSocial: '',
  nome: '',
  cnpj: '',
  celular: '',
  telefone: '',
  email: '',
  logradouro: '',
  pais: 'Brasil',
  estado: '',
  cidade: '',
  cep: '',
  login: '',
  senha: '',
};

export default function CadastrarPrefeitura() {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  useEffect(() => {
    // Buscar estados do IBGE
    fetch('https://servicodados.ibge.gov.br/api/v1/localidades/estados')
      .then(response => response.json())
      .then(data => {
        const sortedEstados = data.sort((a, b) => a.nome.localeCompare(b.nome));
        setEstados(sortedEstados);
      })
      .catch(/*error => console.error('Erro ao buscar estados:', error)*/);
  }, []);

  const formatarTelefone = (valor) => {
    const numbers = valor.replace(/\D/g, '');
    if (numbers.length <= 11) {
      if (numbers.length <= 2) {
        return numbers;
      } else if (numbers.length <= 6) {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
      } else if (numbers.length <= 10) {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
      } else {
        return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
      }
    }
    return valor;
  };

  const formatarCNPJ = (valor) => {
    const numbers = valor.replace(/\D/g, '');
    if (numbers.length <= 14) {
      if (numbers.length <= 2) {
        return numbers;
      } else if (numbers.length <= 5) {
        return `${numbers.slice(0, 2)}.${numbers.slice(2)}`;
      } else if (numbers.length <= 8) {
        return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5)}`;
      } else if (numbers.length <= 12) {
        return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8)}`;
      } else {
        return `${numbers.slice(0, 2)}.${numbers.slice(2, 5)}.${numbers.slice(5, 8)}/${numbers.slice(8, 12)}-${numbers.slice(12)}`;
      }
    }
    return valor;
  };

  const formatarCEP = (valor) => {
    const numbers = valor.replace(/\D/g, '');
    if (numbers.length <= 8) {
      if (numbers.length <= 5) {
        return numbers;
      } else {
        return `${numbers.slice(0, 5)}-${numbers.slice(5)}`;
      }
    }
    return valor;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === 'celular' || name === 'telefone') {
      formattedValue = formatarTelefone(value);
    } else if (name === 'cnpj') {
      formattedValue = formatarCNPJ(value);
    } else if (name === 'cep') {
      formattedValue = formatarCEP(value);
    } else if (name === 'estado') {
      // Buscar cidades quando o estado mudar
      const selectedEstado = estados.find(estado => estado.nome === value);
      if (selectedEstado) {
        fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${selectedEstado.id}/municipios`)
          .then(response => response.json())
          .then(data => {
            const sortedCidades = data.sort((a, b) => a.nome.localeCompare(b.nome));
            setCidades(sortedCidades);
            // Limpar a cidade selecionada quando o estado mudar
            setForm(prevForm => ({ ...prevForm, estado: value, cidade: '' }));
          })
          .catch(/*error => console.error('Erro ao buscar cidades:', error)*/);
      } else {
        setCidades([]);
        setForm(prevForm => ({ ...prevForm, estado: value, cidade: '' }));
      }
      setTouched({ ...touched, estado: true, cidade: false }); // Reset touched for city
      return; // Exit to prevent default form update for state and city
    }

    setForm({ ...form, [name]: formattedValue });
    setTouched({ ...touched, [name]: true });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.razaoSocial) newErrors.razaoSocial = 'Campo obrigatório';
    if (!form.nome) newErrors.nome = 'Campo obrigatório';
    if (!form.cnpj) newErrors.cnpj = 'Campo obrigatório';
    if (!form.celular) newErrors.celular = 'Campo obrigatório';
    //if (!form.email) newErrors.email = 'Campo obrigatório';
    //else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email)) newErrors.email = 'E-mail inválido';
    if (!form.logradouro) newErrors.logradouro = 'Campo obrigatório';
    if (!form.pais) newErrors.pais = 'Campo obrigatório';
    if (!form.estado) newErrors.estado = 'Campo obrigatório';
    if (!form.cidade) newErrors.cidade = 'Campo obrigatório';
    if (!form.cep) newErrors.cep = 'Campo obrigatório';
    if (!form.login) newErrors.login = 'Campo obrigatório';
    if (!form.senha) newErrors.senha = 'Campo obrigatório';
    else if (form.senha.length < 1) newErrors.senha = 'Mínimo um caracteres';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);
    const validationErrors = validate();
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      try {
        setLoading(true);
        
        // Preparar payload no formato da API
        const payload = {
          // Dados do endereço
          END_CEP: form.cep?.trim(),
          END_PAIS: form.pais?.trim(),
          END_ESTADO: form.estado?.trim(),
          END_CIDADE: form.cidade?.trim(),
          END_LOGRADOURO: form.logradouro?.trim(),

          // Dados da prefeitura
          PRE_NOME: form.nome?.trim(),
          PRE_RAZAO_SOCIAL: form.razaoSocial?.trim(),
          PRE_CNPJ: form.cnpj?.trim(),
          PRE_TELEFONE: form.celular?.trim(),
          PRE_EMAIL: form.email?.trim(),

          // Dados do usuário
          USU_LOGIN: form.login?.trim(),
          USU_SENHA: form.senha?.trim()
        };

        const response = await api.post(API_CONFIG.ENDPOINTS.PREFEITURA.CADASTRAR, payload);

        if (response.data.status) {
          message.success(response.data.message || 'Prefeitura cadastrada com sucesso!');
          setForm(initialState);
          setTouched({});
          setSubmitted(false);
        } else {
          message.error(response.data.message || 'Erro ao cadastrar prefeitura');
        }
      } catch (error) {
        //('Erro ao cadastrar prefeitura:', error);
        if (error.response?.status === 401) {
          message.error('Sessão expirada. Por favor, faça login novamente.');
        } else if (error.response?.status === 422) {
          message.error(error.response.data.message || 'Dados inválidos. Verifique os campos preenchidos.');
        } else {
          message.error(error.response?.data?.message || 'Erro ao cadastrar prefeitura');
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const showError = (field) => (submitted || touched[field]) && errors[field];

  return (
    <div className={`home-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <h1 className="modal-title">Cadastrar Prefeitura</h1>
        <div className="modal-content">
          <form className="form-prefeitura" onSubmit={handleSubmit} autoComplete="off">
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Razão Social <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="razaoSocial"
                  placeholder="Razão Social"
                  value={form.razaoSocial}
                  onChange={handleChange}
                  className={showError('razaoSocial') ? 'erro' : ''}
                />
                {showError('razaoSocial') && <span className="msg-erro">{errors.razaoSocial}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Nome Fantasia <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="nome"
                  placeholder="Nome Fantasia"
                  value={form.nome}
                  onChange={handleChange}
                  className={showError('nome') ? 'erro' : ''}
                />
                {showError('nome') && <span className="msg-erro">{errors.nome}</span>}
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">CNPJ <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="cnpj"
                  placeholder="00.000.000/0000-00"
                  value={form.cnpj}
                  onChange={handleChange}
                  className={showError('cnpj') ? 'erro' : ''}
                  maxLength="18"
                />
                {showError('cnpj') && <span className="msg-erro">{errors.cnpj}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Telefone Celular <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="celular"
                  placeholder="(00) 00000-0000"
                  value={form.celular}
                  onChange={handleChange}
                  className={showError('celular') ? 'erro' : ''}
                  maxLength="15"
                />
                {showError('celular') && <span className="msg-erro">{errors.celular}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Telefone Fixo</label>
                <input
                  type="text"
                  name="telefone"
                  placeholder="(00) 0000-0000"
                  value={form.telefone}
                  onChange={handleChange}
                  maxLength="14"
                />
              </div>
              <div className="form-group">
                <label className="form-label">E-mail </label>
                <input
                  type="email"
                  name="email"
                  placeholder="exemplo@email.com"
                  value={form.email}
                  onChange={handleChange}
                  className={showError('email') ? 'erro' : ''}
                />
                {showError('email') && <span className="msg-erro">{errors.email}</span>}
              </div>
            </div>
            <label className="form-label">Endereço:</label>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Logradouro <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="logradouro"
                  placeholder="Rua, Bairro, Número"
                  value={form.logradouro}
                  onChange={handleChange}
                  className={showError('logradouro') ? 'erro' : ''}
                />
                {showError('logradouro') && <span className="msg-erro">{errors.logradouro}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">País <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="pais"
                  placeholder="Brasil"
                  value={form.pais}
                  onChange={handleChange}
                  className={showError('pais') ? 'erro' : ''}
                  readOnly
                />
                {showError('pais') && <span className="msg-erro">{errors.pais}</span>}
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Estado <span className="asterisco-obrigatorio">*</span></label>
                <select
                  name="estado"
                  value={form.estado}
                  onChange={handleChange}
                  className={showError('estado') ? 'erro' : ''}
                >
                  <option value="">Selecione o Estado</option>
                  {estados.map(estado => (
                    <option key={estado.id} value={estado.nome}>
                      {estado.nome}
                    </option>
                  ))}
                </select>
                {showError('estado') && <span className="msg-erro">{errors.estado}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Cidade <span className="asterisco-obrigatorio">*</span></label>
                <select
                  name="cidade"
                  value={form.cidade}
                  onChange={handleChange}
                  className={showError('cidade') ? 'erro' : ''}
                  disabled={cidades.length === 0}
                >
                  <option value="">Selecione a Cidade</option>
                  {cidades.map(cidade => (
                    <option key={cidade.id} value={cidade.nome}>
                      {cidade.nome}
                    </option>
                  ))}
                </select>
                {showError('cidade') && <span className="msg-erro">{errors.cidade}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">CEP <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="cep"
                  placeholder="00000-000"
                  value={form.cep}
                  onChange={handleChange}
                  className={showError('cep') ? 'erro' : ''}
                  maxLength="9"
                />
                {showError('cep') && <span className="msg-erro">{errors.cep}</span>}
              </div>
            </div>
            <label className="form-label">Usuário:</label>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Login <span className="asterisco-obrigatorio">*</span></label>
                <input
                  type="text"
                  name="login"
                  placeholder="Login"
                  value={form.login}
                  onChange={handleChange}
                  className={showError('login') ? 'erro' : ''}
                />
                {showError('login') && <span className="msg-erro">{errors.login}</span>}
              </div>
              <div className="form-group">
                <label className="form-label">Senha <span className="asterisco-obrigatorio">*</span></label>
                <div className="password-input-container">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="senha"
                    placeholder="Senha"
                    value={form.senha}
                    onChange={handleChange}
                    className={showError('senha') ? 'erro' : ''}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                    title={showPassword ? "Ocultar senha" : "Mostrar senha"}
                  >
                    {showPassword ? "👁️" : "👁️‍🗨️"}
                  </button>
                </div>
                {showError('senha') && <span className="msg-erro">{errors.senha}</span>}
              </div>
            </div>
            <div className="form-actions">
              <button 
                type="submit" 
                className="cadastro-submit-button"
                disabled={loading}
              >
                {loading ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
} 